export default __webpack_public_path__ + "images/bb26a7c6256a4762eab30fe042f0b696-detroit_desktop.webp";